<template>
    <div v-if="timer">
        {{ translate("fight.result.details.time") }} {{ timer }}
        <span v-if="roundRepresentation">({{ roundRepresentation }})</span>
    </div>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import { ROUND_OVERTIME_NO_LIMIT, ROUND_OVERTIME_WITH_LIMIT, ROUND_REGULAR, ROUND_SECOND_OVERTIME_WITH_LIMIT } from "../Common/consts";
    import { BracketMatch } from "../Common/Fights/types";
    import { translate } from "../Common/translations";

    const props = defineProps<{
        match: BracketMatch;
    }>();

    const timer = computed(() => props.match?.result?.time ?? null);

    const roundRepresentation = computed(() => {
        if (props.match?.result?.roundType === undefined || props.match?.result?.roundType === null) {
            return null;
        }

        const roundTypeForFight = props.match.result.roundType;

        if (roundTypeForFight === ROUND_OVERTIME_WITH_LIMIT) {
            return translate("fight.result.details.overtime");
        }
        if (roundTypeForFight === ROUND_OVERTIME_NO_LIMIT) {
            if (props.match.result.type === "judo" || props.match.result.type === "newaza") {
                return translate("scoreboard.golden_score");
            } else {
                return translate("fight.result.details.overtime");
            }
        }
        if (roundTypeForFight === ROUND_SECOND_OVERTIME_WITH_LIMIT) {
            return translate("fight.result.details.second_overtime");
        }

        if (roundTypeForFight !== ROUND_REGULAR) {
            return null;
        }

        if (props.match.result.roundNumber) {
            const [roundNumber, maxRounds] = props.match.result.roundNumber.split("/");

            const roundNumberAsInt = parseInt(roundNumber, 10);
            const maxRoundsAsInt = parseInt(maxRounds, 10);

            // If there is only one round then don't show number of rounds.
            if (maxRoundsAsInt === 1) {
                return null;
            }

            if (roundNumberAsInt > 0) {
                return translate("fight.result.details.round", false, [roundNumberAsInt, maxRoundsAsInt]);
            }

            return null;
        }

        return null;
    });
</script>

<style scoped></style>
